module.exports = __webpack_public_path__ + "img/lg_ring_y_i_0_0@3x.c2f631a6.png";